/**
 * Created by yqr on 2018/4/13.
 */
import request from '@/utils/request'
import qs from 'qs';
export default {
  getUser(param){
    return request({
      url: '/front/getUser/'+param,
      method: 'get',
      //params:param
    });
  },
  saveUser(data) {
    return request({
      url: '/user',
      method: 'post',
      data: data
    })
  },
  updateUser(data) {
    return request({
      url: '/user/'+data.id,
      method: 'put',
      data: data
    })
  },
  updatePassword(data) {
    return request({
      url: '/user/pwd/',
      method: 'put',
      data:data
    })
  },

  resetPassword(id,data) {
    return request({
      url: '/user/pwd/'+id,
      method: 'put',
      data:data
    })
  },
  delUser(id){
    return request({
      url: '/user/'+id,
      method: 'delete',
      //params:param
    });
  },
}
export function getInfo(id) {
  return request({
    url: '/front/getUser/'+id,
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js